/* Beaubit theme — interactions. No dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) => {
    const fmt = (window.beaubit && window.beaubit.moneyFormat) || '${{amount}}';
    const v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => k === 'amount_no_decimals' ? Math.round(cents / 100) : v);
  };

  /* ---------- Drawers (menu + cart) ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => { const f = d.querySelector('[data-autofocus], button, a, input'); f && f.focus(); }, 60);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open-drawer]');
    if (open) { e.preventDefault(); openDrawer(open.dataset.openDrawer); return; }
    const close = e.target.closest('[data-close-drawer]');
    if (close) { closeDrawer(close.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    closeMega(); closeSearch();
  });

  /* ---------- Mega menu ---------- */
  let megaTimer;
  function closeMega() { $$('[data-mega-toggle]').forEach((b) => { b.setAttribute('aria-expanded', 'false'); const p = document.getElementById(b.getAttribute('aria-controls')); p && (p.hidden = true); }); }
  function openMega(btn) { closeMega(); btn.setAttribute('aria-expanded', 'true'); const p = document.getElementById(btn.getAttribute('aria-controls')); p && (p.hidden = false); }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-mega-toggle]');
    if (btn) { btn.getAttribute('aria-expanded') === 'true' ? closeMega() : openMega(btn); return; }
    if (!e.target.closest('.catnav')) closeMega();
  });
  document.addEventListener('mouseover', (e) => {
    const item = e.target.closest('.catnav__item');
    if (item) { clearTimeout(megaTimer); const b = item.querySelector('[data-mega-toggle]'); b ? openMega(b) : closeMega(); return; }
    if (e.target.closest('.mega')) { clearTimeout(megaTimer); return; }
    if (!e.target.closest('.catnav') && document.querySelector('[data-mega-toggle][aria-expanded="true"]')) { clearTimeout(megaTimer); megaTimer = setTimeout(closeMega, 150); }
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sub-toggle]'); if (!b) return;
    const open = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', String(!open));
    document.getElementById(b.getAttribute('aria-controls')).hidden = open;
  });

  /* ---------- Search ---------- */
  const search = $('#SearchModal');
  function openSearch() { if (!search) return; search.hidden = false; setTimeout(() => $('input', search).focus(), 30); }
  function closeSearch() { if (search) search.hidden = true; }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-search]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-close-search]') || e.target === search) closeSearch();
  });
  if (search) {
    const input = $('input[name="q"]', search); const out = $('[data-search-results]', search); let t;
    input.addEventListener('input', () => {
      clearTimeout(t); const q = input.value.trim();
      if (!q) { out.innerHTML = out.dataset.empty || ''; return; }
      t = setTimeout(async () => {
        try {
          const r = await fetch(`${window.routes.predictive_search_url}?q=${encodeURIComponent(q)}&section_id=predictive-search`);
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const res = doc.querySelector('[data-predictive]');
          out.innerHTML = res ? res.innerHTML : '';
        } catch (_) { /* keep previous results */ }
      }, 220);
    });
    out.dataset.empty = out.innerHTML;
  }

  /* ---------- Cart ---------- */
  async function refreshCart(open = true) {
    try {
      const r = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`);
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#CartDrawerInner');
      const cur = $('#CartDrawerInner');
      if (fresh && cur) cur.replaceWith(fresh);
      const count = doc.querySelector('[data-cart-count]');
      $$('[data-cart-count]').forEach((el) => (el.textContent = count ? count.textContent : el.textContent));
      if (open) openDrawer('CartDrawer');
    } catch (_) { window.location.href = window.routes.cart_url; }
  }
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]'); const label = btn && btn.innerHTML;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    try {
      const r = await fetch(window.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await r.json();
      if (data.status) { alert(data.description || data.message); } else { await refreshCart(true); }
    } catch (_) { form.submit(); }
    finally { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; } }
  });
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-cart-change]');
    if (!b) return;
    e.preventDefault();
    await fetch(window.routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(b.dataset.line), quantity: Number(b.dataset.qty) }) });
    refreshCart(false);
  });

  /* ---------- Product: variants, gallery, quantity ---------- */
  /* Thumbnail rail: shows a set number of thumbnails, the rest scroll (arrows on desktop, swipe on phones) */
  const smooth = () => (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
  function revealThumb(t) {
    const box = t.closest('[data-thumbs]'); if (!box) return;
    const vertical = box.scrollHeight > box.clientHeight + 1;
    if (vertical) {
      if (t.offsetTop < box.scrollTop) box.scrollTo({ top: t.offsetTop, behavior: smooth() });
      else if (t.offsetTop + t.offsetHeight > box.scrollTop + box.clientHeight) box.scrollTo({ top: t.offsetTop + t.offsetHeight - box.clientHeight, behavior: smooth() });
    } else if (box.scrollWidth > box.clientWidth + 1) {
      if (t.offsetLeft < box.scrollLeft) box.scrollTo({ left: t.offsetLeft, behavior: smooth() });
      else if (t.offsetLeft + t.offsetWidth > box.scrollLeft + box.clientWidth) box.scrollTo({ left: t.offsetLeft + t.offsetWidth - box.clientWidth, behavior: smooth() });
    }
  }
  $$('[data-thumbs]').forEach((box) => {
    const rail = box.closest('.gallery__rail');
    const prev = $('[data-thumbs-scroll="-1"]', rail), next = $('[data-thumbs-scroll="1"]', rail);
    const sync = () => {
      if (prev) prev.disabled = box.scrollTop <= 1;
      if (next) next.disabled = box.scrollTop + box.clientHeight >= box.scrollHeight - 1;
    };
    box.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    const cur = $('[data-thumb][aria-current="true"]', box);
    if (cur) { box.scrollTop = Math.max(0, cur.offsetTop - box.clientHeight + cur.offsetHeight); box.scrollLeft = Math.max(0, cur.offsetLeft - box.clientWidth + cur.offsetWidth); }
    sync();
  });

  $$('[data-product]').forEach((root) => {
    const json = $('[data-variants]', root); if (!json) return;
    const variants = JSON.parse(json.textContent);
    const idInput = $('input[name="id"]', root);
    const priceEl = $('[data-price]', root);
    const atc = $$('[data-atc]', root);
    const optLabels = $$('[data-option-value-label]', root);
    function selected() { return $$('fieldset[data-option-index]', root).map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; }); }
    function update() {
      const opts = selected();
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      optLabels.forEach((l) => { const i = Number(l.dataset.optionValueLabel); l.textContent = opts[i] || ''; });
      if (!v) { atc.forEach((b) => { b.disabled = true; b.textContent = b.dataset.unavailable; }); return; }
      idInput.value = v.id;
      if (priceEl) {
        let h = `<span>${money(v.price)}</span>`;
        if (v.compare_at_price && v.compare_at_price > v.price) h += ` <s><span class="visually-hidden">was </span>${money(v.compare_at_price)}</s> <span class="price__save">save ${Math.round((1 - v.price / v.compare_at_price) * 100)}%</span>`;
        priceEl.innerHTML = h;
      }
      atc.forEach((b) => { b.disabled = !v.available; b.textContent = v.available ? b.dataset.add : b.dataset.soldout; });
      if (v.featured_media) { const t = $(`[data-media-id="${v.featured_media.id}"]`, root); t && t.click(); }
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url);
    }
    root.addEventListener('change', (e) => { if (e.target.closest('fieldset[data-option-index]')) update(); });
  });
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-thumb]');
    if (t) {
      const g = t.closest('.gallery');
      $$('[data-thumb]', g).forEach((x) => x.setAttribute('aria-current', String(x === t)));
      $$('.gallery__slide', g).forEach((s) => (s.hidden = s.dataset.slide !== t.dataset.thumb));
      revealThumb(t);
    }
    const arrow = e.target.closest('[data-thumbs-scroll]');
    if (arrow) {
      const box = $('[data-thumbs]', arrow.closest('.gallery__rail'));
      const first = $('[data-thumb]', box);
      const step = first ? first.offsetHeight + 12 : 100;
      box.scrollBy({ top: Number(arrow.dataset.thumbsScroll) * step, behavior: smooth() });
    }
    const q = e.target.closest('[data-qty]');
    if (q && !q.dataset.line) {
      const input = q.parentElement.querySelector('input');
      input.value = Math.max(1, Math.min(99, Number(input.value) + Number(q.dataset.qty)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const sticky = e.target.closest('[data-sticky-atc]');
    if (sticky) { const f = document.getElementById(sticky.dataset.stickyAtc); f && f.requestSubmit(); }
  });

  /* ---------- Tabs ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[role="tab"]'); if (!t) return;
    const list = t.closest('[role="tablist"]');
    $$('[role="tab"]', list).forEach((x) => { const on = x === t; x.setAttribute('aria-selected', String(on)); const p = document.getElementById(x.getAttribute('aria-controls')); p && (p.hidden = !on); });
  });

  /* ---------- Collection filters ---------- */
  document.addEventListener('change', (e) => {
    const f = e.target.closest('form[data-filters]'); if (f) { f.submit(); return; }
    const s = e.target.closest('select[data-sort]'); if (s) { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u; }
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-toggle-filters]'); if (!b) return;
    const p = document.getElementById(b.getAttribute('aria-controls')); const open = p.classList.toggle('is-open'); b.setAttribute('aria-expanded', String(open));
  });

  /* ---------- Shade finder ---------- */
  const quizPicks = new WeakMap();
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-quiz]'); if (!q) return;
    const steps = $$('[data-step]', q); const result = $('[data-result]', q);
    if (!quizPicks.has(q)) quizPicks.set(q, []);
    const picks = quizPicks.get(q);
    const show = (i) => { steps.forEach((s, j) => (s.hidden = j !== i)); result.hidden = i < steps.length; };
    const opt = e.target.closest('[data-answer]'); const back = e.target.closest('[data-back]'); const again = e.target.closest('[data-again]');
    if (opt) { const i = Number(opt.closest('[data-step]').dataset.step); picks[i] = opt.dataset.answer; if (i + 1 < steps.length) show(i + 1); else { $('[data-summary]', q).textContent = picks.join(' · '); show(steps.length); } }
    if (back) show(Math.max(0, Number(back.closest('[data-step]').dataset.step) - 1));
    if (again) { picks.length = 0; show(0); }
  });

  /* ---------- Scroll reveal ---------- */
  const els = $$('.reveal');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver((es) => es.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => io.observe(el));
  } else { els.forEach((el) => el.classList.add('is-in')); }
  // Theme editor: sections re-render, so show their content straight away.
  document.addEventListener('shopify:section:load', (e) => { $$('.reveal', e.target).forEach((el) => el.classList.add('is-in')); });
})();

/* Pasted descriptions often join words with non-breaking spaces, which stops lines wrapping. Swap them for normal spaces. */
document.querySelectorAll('.rte').forEach((el) => {
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
  let node;
  while ((node = walker.nextNode())) {
    if (node.nodeValue.indexOf('\u00a0') !== -1) node.nodeValue = node.nodeValue.replace(/\u00a0/g, ' ');
  }
});